import(/* webpackMode: "eager" */ "/app/src/components/breadcrumbs/breadcrumbs.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/calculator/calculator.tsx")